






























































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { AttivitaIstituto } from "../../_models/attivitaIstituto";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { bus } from "../../main";

@Component
export default class EditAttivita extends Vue {
  @Prop() info!: AttivitaIstituto;

  private idTipoAttivita: number;
  private dataInizioAttivita: string;
  private dataFineAttivita: string;
  private nomeAttivita: string;
  private nomeAssicurazione: string;
  private numeroAssicurazione: string;
  private descrizioneTipoAttivita: string;
  private numeroProtocollazione: string;
  private dataProtocollazione: string;

  private listaTipiAttivita: any;
  private searchTipoAttivita: object | null;
  private isLoadingTipoAttivita: boolean;
  private startMenu: boolean;
  private finishMenu: boolean;
  private protMenu: boolean;

  private nomeAttivitaRules: [boolean | string];
  private tipoAttivitaRules: [boolean | string];
  private dataInizioAttivitaRules: [boolean | string];
  private dataFineAttivitaRules: [boolean | string];
  private nomeAssicurazioneRules: [boolean | string];
  private numeroAssicurazioneRules: [boolean | string];

  constructor() {
    super();
    this.idTipoAttivita = this.info.idTipoAttivita;
    this.dataInizioAttivita = this.info.dataInizioAttivita;
    this.dataFineAttivita = this.info.dataFineAttivita;
    this.nomeAttivita = this.info.nomeAttivita;
    this.nomeAssicurazione = this.info.nomeAssicurazione;
    this.numeroAssicurazione = this.info.numeroAssicurazione;
    this.descrizioneTipoAttivita = this.info.descrizioneTipoAttivita;
    this.numeroProtocollazione = this.info.numeroProtocollazione;
    this.dataProtocollazione = this.info.dataProtocollazione;

    this.nomeAttivitaRules = [true];
    this.tipoAttivitaRules = [true];
    this.dataInizioAttivitaRules = [true];
    this.dataFineAttivitaRules = [true];
    this.nomeAssicurazioneRules = [true];
    this.numeroAssicurazioneRules = [true];

    this.listaTipiAttivita = [];
    this.searchTipoAttivita = null;
    this.isLoadingTipoAttivita = false;
    this.startMenu = false;
    this.finishMenu = false;
    this.protMenu = false;
  }

  validazioneNomeAttivita() {
    var valid: boolean = false;
    if (this.nomeAttivita !== "" || this.nomeAttivita !== null) {
      valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,50}$/.test(this.nomeAttivita);
    }
    if (valid) {
      this.nomeAttivitaRules = [true];
    } else if (this.nomeAttivita === "" || this.nomeAttivita === null) {
      this.nomeAttivitaRules = ["Nome Attività necessario"];
    } else {
      this.nomeAttivitaRules = [
        "Nome Attività deve essere compresa tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneTipoAttivita() {}
  validazioneDataInizioAttivita() {
    if (this.dataInizioAttivita !== null && this.dataInizioAttivita !== "") {
      this.dataInizioAttivitaRules = [true];
    } else {
      this.dataInizioAttivitaRules = ["Data inizio attività necessaria"];
    }
  }
  validazioneDataFineAttivita() {
    if (this.dataFineAttivita !== null && this.dataFineAttivita !== "") {
      this.dataFineAttivitaRules = [true];
    } else {
      this.dataFineAttivitaRules = ["Data fine attività necessaria"];
    }
  }
  validazioneNomeAssicurazione() {
    var valid: boolean = false;
    if (this.nomeAssicurazione !== "" || this.nomeAssicurazione !== null) {
      valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,50}$/.test(this.nomeAssicurazione);
    }
    if (valid) {
      this.nomeAssicurazioneRules = [true];
    } else if (
      this.nomeAssicurazione === "" ||
      this.nomeAssicurazione === null
    ) {
      this.nomeAssicurazioneRules = ["Nome Assicurazione necessario"];
    } else {
      this.nomeAssicurazioneRules = [
        "Nome Assicurazione deve essere compresa tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneNumeroAssicurazione() {
    var valid: boolean = false;
    if (this.numeroAssicurazione !== "" || this.numeroAssicurazione !== null) {
      valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,50}$/.test(
        this.numeroAssicurazione
      );
    }
    if (valid) {
      this.numeroAssicurazioneRules = [true];
    } else if (
      this.numeroAssicurazione === "" ||
      this.numeroAssicurazione === null
    ) {
      this.numeroAssicurazioneRules = ["Numero Assicurazione necessario"];
    } else {
      this.numeroAssicurazioneRules = [
        "Numero Assicurazione deve essere compresa tra i 2 e i 50 caratteri"
      ];
    }
  }

  async executeTest() {
    this.validazioneNomeAttivita();
    this.validazioneDataInizioAttivita();
    this.validazioneDataFineAttivita();
    this.validazioneNomeAssicurazione();
    this.validazioneNumeroAssicurazione();
  }

  loadTipiAttivita() {
    data
      .dispatchListaTipiAttivita(this["$store"])
      .then(result => {
        this.listaTipiAttivita = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  close() {
    this.idTipoAttivita = this.idTipoAttivita;
    this.dataInizioAttivita = this.dataInizioAttivita;
    this.dataFineAttivita = this.dataFineAttivita;
    this.nomeAttivita = this.nomeAttivita;
    this.nomeAssicurazione = this.nomeAssicurazione;
    this.numeroAssicurazione = this.numeroAssicurazione;
    this.descrizioneTipoAttivita = this.descrizioneTipoAttivita;

    this.nomeAttivitaRules = [true];
    this.tipoAttivitaRules = [true];
    this.dataInizioAttivitaRules = [true];
    this.dataFineAttivitaRules = [true];
    this.nomeAssicurazioneRules = [true];
    this.numeroAssicurazioneRules = [true];

    this.searchTipoAttivita = null;
    this.isLoadingTipoAttivita = false;
    bus.$emit("closeEditDialog");
  }

  save() {
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var nomeTipoAttivita: string = "";
        var index: number = 0;

        for (let i = 0; i < this.listaTipiAttivita.length; i++) {
          if (
            this.listaTipiAttivita[i].idTipoAttivita === this.idTipoAttivita
          ) {
            index = i;
          }
        }
        nomeTipoAttivita = this.listaTipiAttivita[index]
          .descrizioneTipoAttivita;
        var payload: AttivitaIstituto = {
          idAttivita: this.info.idAttivita,
          idTipoAttivita: this.idTipoAttivita,
          dataInizioAttivita: this.dataInizioAttivita,
          dataFineAttivita: this.dataFineAttivita,
          nomeAttivita: this.nomeAttivita,
          nomeAssicurazione: this.nomeAssicurazione,
          numeroAssicurazione: this.numeroAssicurazione,
          descrizioneTipoAttivita: nomeTipoAttivita,
          statoIscrizione: this.info.statoIscrizione,
          idIstituto: 0,
          idAnnoScolastico: 0,
          numeroProtocollazione: this.numeroProtocollazione,
          dataProtocollazione: this.dataProtocollazione,
          statoPubblicazione: false
        };

        user
          .dispatchEditAttivitaIstituto(this["$store"], payload)
          .then(() => {
            bus.$emit("editedAttivita");
            bus.$emit(
              "successfullOperation",
              "Attività modificata con successo"
            );
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      }
    });
  }

  formatDate(dataInput: string) {
    const [day, month, year] = dataInput.split("/");
    return `${year}-${month}-${day}`;
  }

  created() {
    this.dataInizioAttivita = this.formatDate(this.dataInizioAttivita);
    this.dataFineAttivita = this.formatDate(this.dataFineAttivita);
    this.dataProtocollazione = this.formatDate(this.dataProtocollazione)
    this.loadTipiAttivita();
  }
}
